import { render, staticRenderFns } from "./CatBenefits.vue?vue&type=template&id=3ee3ed8b&"
import script from "./CatBenefits.vue?vue&type=script&lang=js&"
export * from "./CatBenefits.vue?vue&type=script&lang=js&"
import style0 from "./CatBenefits.vue?vue&type=style&index=0&id=3ee3ed8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports